import styled from "styled-components";
import css from "@styled-system/css";
import { SpaceProps, space } from "styled-system";
import useFetch from "react-fetch-hook";

import Box from "../Box/Box";
import { buildLegalInfo } from "../LegalInfoBuilder";
import { LinkProps } from "./BCAFooter";

export interface LegalInfoProps {
	legalInfoUrl: string;
}

export type LegalInfoLinksProps = LinkProps[];

const Copyright = styled.span`
	${css({ fontSize: ["body", "caption"] })}
`;

const LegalInfoContainer = styled(Box)`
	${css({
		columnGap: [6, 5],
	})}
`;

const LegalInfoLink = styled.a<SpaceProps>`
	${css({
		color: "primary-white",
		textDecoration: "none",
		fontSize: ["body", "caption"],
		fontWeight: "semiBold",
		"&:hover": {
			color: "primary-light-blue",
			textDecoration: "underline",
		},
		"&:focus-within": {
			color: "primary-light-blue",
			textDecoration: "underline",
		},
	})};
	${space};
`;

export default function LegalInfo({ legalInfoUrl }: LegalInfoProps) {
	const copyrightSymbol = "\u00A9";
	const copyrightYear = new Date().getFullYear();
	const { data } = useFetch(legalInfoUrl);
	const legalInfo = buildLegalInfo(data);

	return (
		<Box
			data-testid="legal-info-section"
			display="flex"
			flexDirection={["column", "row"]}
			alignItems={["center", "flex-start"]}
			color="primary-white"
			mb={[4, 3]}
		>
			<Copyright>
				{copyrightSymbol} {copyrightYear} BCA. All Rights Reserved
			</Copyright>
			<LegalInfoContainer
				display="flex"
				mt={[4, "0px"]}
				justifyContent={["center", "flex-start"]}
				flexWrap="wrap"
				marginLeft={[0, 5]}
			>
				{legalInfo.map((item: LinkProps, index: number) => {
					return (
						item.isVisible && (
							<LegalInfoLink
								key={item.id}
								href={item.link}
								target={item.openInNewWindow ? "_blank" : "_top"}
							>
								{item.label}
							</LegalInfoLink>
						)
					);
				})}
			</LegalInfoContainer>
		</Box>
	);
}
